import { createContext } from "react";

const tourContext = createContext({
    tourState: [],
    setTour: tour => {}
});

export default tourContext;